import { useAtomValue } from "jotai";

import { PrivateTimeSlotCard } from "@whoosh/design-system/src/apps/PatronApp/screens/teesheet/components/TeeSheet/TimeSlotCard/";
import { Box } from "@whoosh/design-system/src/components/primitive";
import { dateUtils } from "@whoosh/utilities";

import { isBookingMultipleTeeTimesAtom } from "../../../../atoms";
import { RestrictionBlockProps } from "../RestrictionBlock";
import { RequestTimeSlotRowHeader } from "../RestrictionRequest/RequestTimeSlotRowHeader";
import {
  TimeSlotListBlock,
  TimeSlotListBlockProps,
} from "../TimeSlotListBlock";
import { SlotAvailability } from "../__generated__/TimeSlotListInternalQuery.graphql";

export type GroupedRequestSlotRowProps = {
  type: "RequestSlot";
  index: number;
  id: string;
  time: string;
  availability: SlotAvailability;
  course: { id?: string; name?: string };
  restriction?: RestrictionBlockProps;
  onSlotPress: (id: string, timeString: string) => void;
};

export type GroupedRequestBlockRowProps = {
  type: "Block";
  id: string;
  time: string;
  block: TimeSlotListBlockProps;
  restriction?: RestrictionBlockProps;
};

export type GroupedRequestRowProps =
  | GroupedRequestSlotRowProps
  | GroupedRequestBlockRowProps;

export const GroupedRequestTimeSlotRow = ({
  requestRestrictionsSlots,
  showHeader = true,
}: {
  requestRestrictionsSlots: GroupedRequestRowProps[];
  showHeader?: boolean;
}) => {
  const isBookingMultipleTeeTimes = useAtomValue(isBookingMultipleTeeTimesAtom);
  const canUpdate = !isBookingMultipleTeeTimes;
  const firstRequestSlot = requestRestrictionsSlots.find(
    (requestRestrictionsSlot) => requestRestrictionsSlot.type === "RequestSlot"
  );
  const headerRestriction =
    requestRestrictionsSlots[0].restriction ?? firstRequestSlot?.restriction;
  const headerCourseName =
    firstRequestSlot?.type === "RequestSlot"
      ? firstRequestSlot.course?.name
      : undefined;

  return (
    <>
      {showHeader && headerRestriction ? (
        <RequestTimeSlotRowHeader
          courseName={headerCourseName}
          restriction={headerRestriction}
        />
      ) : null}
      {requestRestrictionsSlots.map((requestRestrictionsSlot, i) => {
        if (requestRestrictionsSlot.type === "Block") {
          return (
            <Box
              key={`block-${requestRestrictionsSlot.id}-${requestRestrictionsSlot.time}`}
              mt={1}
              mb={i === requestRestrictionsSlots.length - 1 ? 4 : 0}
            >
              <TimeSlotListBlock {...requestRestrictionsSlot.block} />
            </Box>
          );
        }

        const timeString =
          dateUtils.formatHHMM(requestRestrictionsSlot.time) || undefined;
        const onPress = !isBookingMultipleTeeTimes
          ? () =>
              requestRestrictionsSlot.onSlotPress(
                requestRestrictionsSlot.id,
                requestRestrictionsSlot.time
              )
          : undefined;
        return (
          <Box
            key={`request-${requestRestrictionsSlot.id}-${requestRestrictionsSlot.time}`}
            mt={1}
            mb={i === requestRestrictionsSlots.length - 1 ? 4 : 0}
          >
            <PrivateTimeSlotCard
              players={[]}
              canUpdate={canUpdate}
              isRequestAvailable={true}
              time={timeString}
              onPress={onPress}
              borderRadius={
                i === requestRestrictionsSlots.length - 1
                  ? { bottom: "2" }
                  : undefined
              }
            />
          </Box>
        );
      })}
    </>
  );
};
